module.exports = __webpack_public_path__ + "img/tu05.392aae3a.jpg";